import { Box, Stack, Typography } from '@mui/material';
import MemoryIcon from '@mui/icons-material/Memory';
import { useMemo } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { getBitsElectronicIcon } from '../../../../utils/getBitsElectronicIcon';
import { countRequiredElectronicsByType } from '../../../../utils/requiredElectronicsCounts';

export interface Electronic {
  ELECTRONIC_TYPE: string;
}

interface TemplateCardProps {
  templateKey: string;
  templateTitle: string;
  templateElectronics?: Electronic[];
  selected: boolean;
}

const TemplateCard = ({ templateKey, templateTitle, templateElectronics, selected }: TemplateCardProps) => {
  const { t } = useTranslation();
  const electronicsWithCounts = useMemo(() => countRequiredElectronicsByType(templateElectronics ?? []), [templateElectronics]);

  return (
    <Stack
      direction="row"
      justifyContent={'center'}
      alignItems={'center'}
      spacing={2}
      border={selected ? 'solid' : 'none'}
      borderColor={'primary.main'}
      borderRadius={2}
      padding={1}
    >
      <Stack justifyContent={'center'} alignItems={'center'} width={'100%'} maxWidth={85}>
        <Typography variant="body2">
          <Trans i18nKey={`robotTemplateDialog.templateCard.title.${templateKey}`}>{templateTitle}</Trans>
        </Typography>
        <Box width={75} height={75} bgcolor={'text.primary'} borderRadius={3}></Box>
      </Stack>
      <Stack>
        {templateElectronics && (
          <Stack direction="row" display={'flex'} alignItems={'center'} flexWrap="wrap" gap={0.5}>
            <Typography fontSize={10}>
              <Trans i18nKey="robotTemplateDialog.required-electronics">Required Electronics:</Trans>
            </Typography>
            {Object.entries(electronicsWithCounts).map(([electronicType, count]) => {
              const ElectronicIcon = getBitsElectronicIcon(electronicType);

              return (
                <Stack key={electronicType} direction="row" alignItems="center" spacing={0.25}>
                  {ElectronicIcon ? (
                    <Box component={ElectronicIcon} aria-hidden sx={{ width: 16, height: 16, display: 'block' }} />
                  ) : (
                    <MemoryIcon fontSize="small" />
                  )}
                  {count > 1 ? (
                    <Typography component="span" fontSize={10}>
                      {t('rapidRobots.electronics.quantity', { count, defaultValue: 'x{{count}}' })}
                    </Typography>
                  ) : null}
                </Stack>
              );
            })}
          </Stack>
        )}
        <Typography variant="caption">
          <Trans i18nKey={`robotTemplateDialog.description.${templateKey}`}>
            Place holder text for the various robot templates descriptions. This will be filled with a description of what the robot this template is
            for and what the robot needs. Lorem ipsum dolor sit amet consectetur adipiscing elit. Consectetur adipiscing elit quisque faucibus ex
            sapien vitae.
          </Trans>
        </Typography>
      </Stack>
    </Stack>
  );
};

export default TemplateCard;
